// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar__ezgQ1","preloader":"preloader__KW+OK","label":"label__ezc9E","row":"row__u2zAV","col":"col__K9+cu"};